import * as React from 'react';

import Timeline from '@mui/lab/Timeline';
import { timelineOppositeContentClasses } from '@mui/lab/TimelineOppositeContent';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import EventCard from './components/EventCard';
import { useBoundStore } from '../../stores';

const events = [
  {
    beginDate: '2023-10-07T08:41:58',
    endDate: '2023-10-07T09:41:58',
    allDay: true,
    title: 'Event 1',
    description: 'Event 1 Description',
  },
  {
    beginDate: '2023-10-07T09:41:58',
    endDate: '2023-10-07T10:41:58',
    allDay: false,
    title: 'Event 4',
    description: 'Event 4 Description',
  },
  // {
  //   beginDate: '2023-10-07T10:41:58',
  //   endDate: '2023-10-07T10:41:58',
  //   allDay: false,
  //   title: 'Event 5',
  //   description: 'Event 5 Description',
  // },
  // {
  //   beginDate: '2023-10-07T10:41:58',
  //   endDate: '2023-10-07T10:41:58',
  //   allDay: false,
  //   title: 'Event 2',
  //   description: 'Event 2 Description',
  // },
  // {
  //   beginDate: '2023-10-07T10:41:58',
  //   endDate: '2023-10-07T10:41:58',
  //   allDay: false,
  //   title: 'Event 3',
  //   description: 'Event 3 Description',
  // },
];

export default function LeftAlignedTimeline() {
  const [value, setValue] = React.useState(0);
  const textPool = useBoundStore((state) => state.textPool);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <>
      {/* Should be sorted by date (Week, Month, Day) */}
      <div className="flex justify-center items-center m-2 ">
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label={textPool['Gün']} />
          <Tab label={textPool['Hafta']} />
          <Tab label={textPool['Ay']} />
        </Tabs>
      </div>
      <Timeline
        sx={{
          [`& .${timelineOppositeContentClasses.root}`]: {
            flex: 0.3,
          },
          '.MuiTimelineDot-root': {
            backgroundColor: '#2E4665',
          },
          '.MuiTimelineConnector-root': {
            backgroundColor: '#2E4665',
            width: '5px',
            borderRadius: '50px',
          },
        }}
      >
        {events.map((event, index) => {
          return (
            <EventCard
              key={index}
              event={event}
              eventsLength={events.length}
              index={index}
            />
          );
        })}
      </Timeline>
    </>
  );
}
